import React from 'react';
import { Apartment, Mail } from "@material-ui/icons";
import { deepOrange } from '@material-ui/core/colors';
import Footer from './Footer';

const Contact = () => {
    return (
        <>
            <section id="contact">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 mx-auto text-center">
                            <h2 className="text-dark">Let's Get In Touch!</h2>
                            <hr className="my-4 mx-auto" />
                            <p className="mb-5">Ready to start your next project with us? That's great! Please visit us or drop an email with your requirements and we will get back to you as soon as possible!</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 ml-auto text-center">
                            <Apartment style={{ color: deepOrange[600], fontSize: 90 }} />
                            <h5>Biswanath, Assam - 784176</h5>
                        </div>
                        <div className="col-lg-4 mr-auto text-center">
                            <Mail style={{ color: deepOrange[600], fontSize: 90 }} />
                            <h5>0n3<small>[dot]</small>a77<small>[at]</small>gmail<small>[dot]</small>com</h5>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default Contact
